import $ from 'jquery';
import emojiDictionary from 'emoji-dictionary';

import {BaseView} from './views/base-view';
import {loc} from './localizations';
import _ from 'underscore';


class FormValidation extends BaseView {
  constructor(el) {
    super(el, {
      'inputGroups': '[class*="form-group--"]',
      'emailField': '.stage-form-email',
      'requiredField': 'input.stage-required, textarea.stage-required, .control--checkbox.stage-required input',
      'textFields': 'input, textarea',
      'submitButton': 'input[type="submit"]',
      'formMessage': '.error--message'
    });

    this._addMessageElements();
  }


  /**
  * Checks that field has value,updates error message
  * @param {JQuery} field input element
  * @return {boolean} field validity
  */
  _checkRequired(field) {

    const inputname = field.attr('name');
    const fieldParent = field.parents('[class*="form-group--"]');
    const messageElement = fieldParent.find('.field-message');

    let value = field.attr('type') !== 'checkbox' && field.attr('type') !== 'radio' ? field.val() : fieldParent.find('input[name="'+ inputname +'"]:checked').val();

    let msg = loc('form_required');

    if (field.attr('pattern')) {
      const regNumberFormat = new RegExp(field.attr('pattern'));
      value = regNumberFormat.test(value.toUpperCase()) ? 1 : 0;

      //Mistä ihmeestä stagen locations lista luodaan? En keksinyt, miten sieltä saisi jonkun uuden arvon tänne joten kovakoodattuna nyt.
      msg = loc('form_error_invalid_value');
    }

    //if no value, show error
    field.toggleClass('error', !value);
    const errorMessage = value ? '': msg;
    messageElement.text(errorMessage);
    messageElement.toggleClass('field-message--error', !value);

    return !!value; //return boolean value
  }
  /**
  * Checks email field for value and value format
  * @param {JQuery} field input element
  * @return {boolean} field validity
  */
  _checkEmail(field) {

    const fieldParent = field.parents('[class*="form-group--"]');
    const messageElement = fieldParent.find('.field-message');

    //checks for email format (text + @ + text + . + text)
    const filter = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9])+$/;

    const value =  field.val();
    const valid = (!value || filter.test(value)) && (!field.hasClass('stage-required') || this._checkRequired(field)); //email is either empty or passes email test

    //if not valid, show error
    field.toggleClass('error', !valid);
    const errorMessage = valid ? '': loc('form_email_format');
    messageElement.text(errorMessage);
    messageElement.toggleClass('field-message--error', !!errorMessage);

    return valid;
  }


  /**
  * Checks that dropdown has selection, updates error message
  * @param {string} inputname name of the input
  * @return {boolean} field validity
  */
  _checkDropdown(inputname) {
    const input = this.$el.find('input[name="'+ inputname +'"]');
    const valid = this.$el.find('input[name="'+ inputname +'"]:checked').length > 0; //if some value is selected, input is valid

    const dropdownParent = input.parents('[class*="form-group--"]');
    const messageElement = dropdownParent.find('.field-message');

    //if nothing is selected, show error
    dropdownParent.toggleClass('error', !valid);
    const errorMessage = valid ? '': loc('form_required');

    messageElement.text(errorMessage);
    messageElement.toggleClass('field-message--error', !!errorMessage);

    return valid;
  }

  /**
  * Replaces emojis with with emoji-name
  * @param {string} str text that might contain emojis
  * @return {string} text where emojis have been replaced
  */
  _convertEmojisToText(str){
    const emojiRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    return str.replace(emojiRegex, function(match, contents, offset, input_string) {
      return ':' + emojiDictionary.getName(match) + ':';
    });
  }

  /**
  * Validates input fields inside the from
  * @param {JQuery} form form element
  * @return {boolean} form validity
  */
  _validateFields(form) {
    const self = this;
    const invalidFields = [];
    let isValid = true;

    //check required fields to see if they are filled
    this.$dom.requiredField.each(function() {
      const isFieldValid = self._checkRequired($(this));
      if (!isFieldValid ) {
        invalidFields.push($(this));
      }
    });

    //check email fields to see if they are in correct format
    this.$dom.emailField.each(function() {
      const isFieldValid = self._checkEmail($(this));
      if (!isFieldValid) {
        invalidFields.push($(this));
      }
    });

    //check required dropdowns
    let requiredDropdowns = form.find('.stage-required .dropdown__options input[type="radio"]');
    requiredDropdowns = _.uniq(requiredDropdowns, function(input) {
      return input.name;
    });

    const hasDropdownErrors = requiredDropdowns.some(item => {
      return !this._checkDropdown(item.name); //if input is not valid, return true
    });

    isValid = invalidFields.length === 0 && !hasDropdownErrors;

    if(isValid) {
      //before submission, convert emojis to text
      this.$dom.textFields.each(function() {
        const value =  self._convertEmojisToText($(this).val());
        $(this).val(value);
      });
    }

    //shift focus to first failed field
    if(invalidFields.length) {
      invalidFields[0].focus();
    }

    return isValid;
  }




  //add message elements under the fields
  _addMessageElements() {
    this.$dom.inputGroups.each(function(){
      $(this).append('<div class="field-message"></div>');
    });
  }

  //input event listeners
  bindEventListeners() {

    //field validation on blur and change events (excluding dropdown)
    this.$dom.requiredField.on( 'blur', (event) => { this._checkRequired($(event.target)); });
    this.$dom.requiredField.on( 'change', (event) => { this._checkRequired($(event.target)); });
    this.$dom.emailField.on( 'blur', (event) => { this._checkEmail($(event.target)); });
    this.$dom.emailField.on( 'change', (event) => { this._checkEmail($(event.target)); });

    //cancels default submit event and makes the validation first
    this.$dom.submitButton.on('click', (event) => {
      event.preventDefault();
      // validate whole form
      if(this._validateFields(this.$el)){
        this.$el.submit();
      } else {
        this.$el.addClass('form--error');
        this.$dom.formMessage.text(loc('form-error'));
      }
    });

  }


}

// get DOM elements
function init () {
  if( $('.validate-form').length) {
    const formValidation = new FormValidation('.validate-form');
    formValidation.bindEventListeners();
  }
}

export default { init };
export { init };
